import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=3ee02fd5&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee02fd5')) {
      api.createRecord('3ee02fd5', component.options)
    } else {
      api.reload('3ee02fd5', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=3ee02fd5&", function () {
      api.rerender('3ee02fd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/contact.vue"
export default component.exports